import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AdminIcon from '../../assets/customIcon/admin-icon.svg';
import elfoLogo from '../../assets/elfo_A2P.png';
import avatar from '../../assets/elfo_icon_new.svg';
import perkesoLogo from '../../assets/logo-perkeso.png';
import { getRequest } from '../../helpers/apiHandler';
import { formatWithoutCurrency } from '../../helpers/helperFunction';
import { onLogout, setLoginSuccess } from '../../store/actions/reduxAction';
import ConfirmationModal from '../shared/apiLifeCycle/ConfirmationModal';
import { ProfilePictureCircle } from './AdminLogos';

const baseUrl = process.env.PUBLIC_URL;
const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const AdminTopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { access_token, available_balance, name, verified, currency, role } = useSelector(
    (state) => state.auth.user
  );
  const { reload_top_bar } = useSelector((state) => state.topbar);
  const [showModalFlag, setShowModalFlag] = useState(false);
  const verifiedColor = verified ? '#00abe0' : '#b5b6b7';

  const handleRemove = () => {
    dispatch(onLogout());
    localStorage.clear();
    navigate('/login');
  };

  const check_if_logged_in = () => {
    if (!access_token) return navigate('/login');
    if (role !== 'admin') return navigate('/dashboard');

    const data = { headers: { Authorization: access_token.token } };
    getRequest('/user/me', data, (res) => {
      if (res.success) {
        dispatch(setLoginSuccess(res));

        // Moving the forced navigate by role to here, because of the balance wont be updated if we put it up there
        // Add checks if the current user is already has logged in then don't redirect...
        if (role === 'admin' && !location.pathname.includes('/admin/')) return navigate('/admin/dashboard');
      }
      if (res.error) {
        return navigate('/login');
      }
    });
  };

  const renderCredits = (revenue) => {
    if (!white_label_perkeso) {
      return (<></>)
    }
    const formattedRevenue = formatWithoutCurrency(revenue || 0, 0)
    const revenueClass = parseFloat(revenue) > 0 ? 'text-success' : 'text-error';

    return (
      <li className="nav-item account-status">
        <div className="trial-credits">
          <span>{white_label_perkeso ? 'CREDIT BALANCE' : '1 DAY REVENUE'}</span>
          <span className={revenueClass}>
            {white_label_perkeso ? `${formattedRevenue}` : `${currency.symbol} ${formattedRevenue}`}
          </span>
        </div>
      </li>
    );
  };

  useEffect(() => {
    check_if_logged_in();
  }, [reload_top_bar]);

  return (
    <div className="topbar">
      <div className="top-bar-component-container pb-1">
        <nav className="navbar navbar-expand navbar-light pt-0 pb-0">
          <Link className={white_label_perkeso ? "navbar-brand-p" : "navbar-brand"} to={`${baseUrl}/admin/dashboard`}>
            <img
              className="elfoLogo"
              alt="background-vector"
              src={white_label_perkeso ? perkesoLogo : elfoLogo}
            />
          </Link>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              {renderCredits(available_balance)}
              <li className="nav-item dropdown">
                <div className="user-profile nav-link pr-0">
                  <ProfilePictureCircle />
                  <img src={avatar} className={'with-avatar'} alt="Avatar" />
                </div>
                <div
                  className="nav-link dropdown-toggle user-profile-dropdown"
                  href="#"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="username">
                    <span>{name}</span>
                    <img alt="..." src={AdminIcon} />
                    <i className="fas fa-chevron-down ml-2" />
                  </div>
                </div>
                <div
                  className="dropdown-menu name-initials-dropdown"
                  aria-labelledby="navbarDropdown"
                >
                  <div className="dropdown-divider" />
                  <button className="dropdown-item dropdown-item-logout" onClick={handleRemove}>
                    <i className="fas fa-sign-out-alt mr-2" />
                    Logout
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <ConfirmationModal
        show={showModalFlag}
        close={() => setShowModalFlag(false)}
        onClick={handleRemove}
        message="Are you sure you want to logout?"
        btns={{
          leftBtn: 'Cancel',
          rightBtn: 'Confirm',
        }}
      />
    </div>
  );
};

export default AdminTopBar;
